"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 3.923c-4.461 0-8.077 3.616-8.077 8.077S7.539 20.077 12 20.077s8.077-3.616 8.077-8.077S16.461 3.923 12 3.923m0 14.808a6.73 6.73 0 1 1 0-13.462 6.73 6.73 0 0 1 0 13.462"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M18.119 12a6.12 6.12 0 1 1-12.24-.001A6.12 6.12 0 0 1 18.12 12"
  })]
}), 'CameraButton');
//# sourceMappingURL=index.js.map